
    // Price tables
    const PRICES = {
      standard: { small: 500, medium: 700, large: 850, roof: 1100 },
      premium:  { small: 800, medium: 1000, large: 1200, roof: 1500 }
    };

    // Volume discount based on total pieces count
    function getVolumeDiscountRate(totalPieces){
      // note: intervals overlap at boundary 5 and 8 in your text; we interpret as:
      // 0-2: 0%, 3-4: 5%, 5-7: 10%, 8-15: 15%, >15: still 15% (cap) for safety
      if (totalPieces >= 8) return 0.15;
      if (totalPieces >= 5) return 0.10;
      if (totalPieces >= 3) return 0.05;
      return 0;
    }

    function money(n){
      // round to whole lei (prices are whole; adjustments may create decimals)
      const rounded = Math.round(n);
      return rounded.toLocaleString('ro-RO') + ' lei';
    }

    const els = {
      tier: document.getElementById('tier'),
      paint: document.getElementById('paint'),
      paintHint: document.getElementById('paintHint'),
      small: document.getElementById('small'),
      medium: document.getElementById('medium'),
      large: document.getElementById('large'),
      roof: document.getElementById('roof'),

      priceSmall: document.getElementById('priceSmall'),
      priceMedium: document.getElementById('priceMedium'),
      priceLarge: document.getElementById('priceLarge'),
      priceRoof: document.getElementById('priceRoof'),

      calcBtn: document.getElementById('calcBtn'),
      resetBtn: document.getElementById('resetBtn'),

      totalValue: document.getElementById('totalValue'),
      piecesTag: document.getElementById('piecesTag'),
      tiersTag: document.getElementById('tiersTag'),
      summaryLine: document.getElementById('summaryLine'),

      subtotalPieces: document.getElementById('subtotalPieces'),
      discountVolume: document.getElementById('discountVolume'),
      paintAdjust: document.getElementById('paintAdjust'),
      grandTotal: document.getElementById('grandTotal'),
      detailsNote: document.getElementById('detailsNote'),

      volDiscountPill: document.getElementById('volDiscountPill')
    };

    function clampInt(v){
      const n = Number(v);
      if (!Number.isFinite(n) || n < 0) return 0;
      return Math.floor(n);
    }

    function updatePriceTags(){
      const tier = els.tier.value;
      els.priceSmall.textContent  = money(PRICES[tier].small)  + ' / piesă';
      els.priceMedium.textContent = money(PRICES[tier].medium) + ' / piesă';
      els.priceLarge.textContent  = money(PRICES[tier].large)  + ' / piesă';
      els.priceRoof.textContent   = money(PRICES[tier].roof)   + ' / piesă';

      // 2K is standard-only
      if (tier === 'premium' && els.paint.value === '2k') {
        els.paint.value = 'normal';
      }
      els.paint.querySelector('option[value="2k"]').disabled = (tier === 'premium');

      if (tier === 'premium') {
        els.paintHint.textContent = 'La Premium, 2K (-15%) nu este disponibil (conform listei).';
      } else {
        els.paintHint.textContent = 'La Standard, poți aplica 2K (-15%) sau Triplu strat (+20%).';
      }

      // update volume pill preview
      const totalPieces = clampInt(els.small.value) + clampInt(els.medium.value) + clampInt(els.large.value) + clampInt(els.roof.value);
      const rate = getVolumeDiscountRate(totalPieces);
      const label = rate === 0 ? '—' : `-${Math.round(rate*100)}%`;
      els.volDiscountPill.innerHTML = `Reducere volum: <strong>${label}</strong>`;
    }

    function calculate(){
      const tier = els.tier.value;
      const paint = els.paint.value;

      const qty = {
        small:  clampInt(els.small.value),
        medium: clampInt(els.medium.value),
        large:  clampInt(els.large.value),
        roof:   clampInt(els.roof.value)
      };
      const totalPieces = qty.small + qty.medium + qty.large + qty.roof;

      const base = PRICES[tier];
      const subtotalPieces =
        qty.small  * base.small +
        qty.medium * base.medium +
        qty.large  * base.large +
        qty.roof   * base.roof;

      const volRate = getVolumeDiscountRate(totalPieces);
      const volDiscount = subtotalPieces * volRate;
      const afterVolume = subtotalPieces - volDiscount;

      // Paint adjustments apply after volume discount (common pricing approach)
      let paintRate = 0;
      let paintLabel = 'Normal';
      if (paint === '2k') { paintRate = -0.15; paintLabel = '2K (-15%)'; }
      if (paint === 'triple') { paintRate = 0.20; paintLabel = 'Triplu strat (+20%)'; }

      // Enforce standard-only for 2K
      if (tier === 'premium' && paint === '2k') {
        paintRate = 0;
        paintLabel = 'Normal (2K indisponibil la Premium)';
      }

      const paintAdjust = afterVolume * paintRate;
      const total = afterVolume + paintAdjust;

      // UI output
      els.totalValue.textContent = money(total);
      els.grandTotal.textContent = money(total);

      els.piecesTag.textContent = `${totalPieces} ${totalPieces === 1 ? 'piesă' : 'piese'}`;
      els.tiersTag.textContent = `${tier === 'standard' ? 'Standard' : 'Premium'} • ${paintLabel}`;

      els.subtotalPieces.textContent = money(subtotalPieces);
      els.discountVolume.textContent = (volDiscount === 0) ? money(0) : `-${money(volDiscount).replace(' lei','')} lei`;
      els.paintAdjust.textContent = (paintAdjust === 0) ? money(0) : (paintAdjust > 0 ? `+${money(paintAdjust).replace(' lei','')} lei` : `-${money(Math.abs(paintAdjust)).replace(' lei','')} lei`);

      const volText = volRate === 0 ? 'fără reducere volum' : `reducere volum ${Math.round(volRate*100)}%`;
      els.summaryLine.textContent = totalPieces === 0
        ? 'Nu ai selectat nicio piesă.'
        : `Calcul pentru ${totalPieces} piese, ${volText}, ${paintLabel}.`;

      // Details note
      const lines = [];
      if (qty.small)  lines.push(`• Piese mici: ${qty.small} × ${money(base.small)} = ${money(qty.small * base.small)}`);
      if (qty.medium) lines.push(`• Piese medii: ${qty.medium} × ${money(base.medium)} = ${money(qty.medium * base.medium)}`);
      if (qty.large)  lines.push(`• Piese mari: ${qty.large} × ${money(base.large)} = ${money(qty.large * base.large)}`);
      if (qty.roof)   lines.push(`• Plafon: ${qty.roof} × ${money(base.roof)} = ${money(qty.roof * base.roof)}`);

      els.detailsNote.textContent = lines.length ? lines.join('\n') : '';
      els.detailsNote.style.whiteSpace = 'pre-line';
    }

    function resetAll(){
      els.tier.value = 'standard';
      els.paint.value = 'normal';
      els.small.value = 0;
      els.medium.value = 0;
      els.large.value = 0;
      els.roof.value = 0;
      updatePriceTags();

      els.totalValue.textContent = '0 lei';
      els.subtotalPieces.textContent = '0 lei';
      els.discountVolume.textContent = '0 lei';
      els.paintAdjust.textContent = '0 lei';
      els.grandTotal.textContent = '0 lei';
      els.piecesTag.textContent = '0 piese';
      els.tiersTag.textContent = '—';
      els.summaryLine.textContent = 'Completează piesele și apasă „Calculează”.';
      els.detailsNote.textContent = '';
    }

    // Events
    [els.tier, els.paint, els.small, els.medium, els.large, els.roof].forEach(el => {
      el.addEventListener('input', updatePriceTags);
      el.addEventListener('change', updatePriceTags);
    });

    els.calcBtn.addEventListener('click', calculate);
    els.resetBtn.addEventListener('click', resetAll);

    // initial
    updatePriceTags();
    resetAll();